import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import Icon from "components/library/Icon";
import { MESSAGES, MESSAGE_VISIBILITY_DURATION } from "config/constants";

import styles from "./Message.css";

export default class Message extends React.Component {
  componentDidMount() {
    this.visibilityTimer = window.setTimeout(() => {
      this.props.expire();
    }, MESSAGE_VISIBILITY_DURATION * 1000);
  }

  componentWillUnmount() {
    if (this.visibilityTimer) {
      window.clearTimeout(this.visibilityTimer);
    }
  }

  render() {
    const { message } = this.props;

    // TODO: Define constants for type?
    let { type } = this.props;

    if (!type) {
      if (message instanceof Error) {
        type = MESSAGES.failure;
      } else {
        type = MESSAGES.info;
      }
    }

    let icon;

    if (type === MESSAGES.success) {
      icon = "check-circle";
    } else if (type === MESSAGES.failure) {
      icon = "x-circle";
    } else {
      icon = "info";
    }

    return (
      <div className={classNames(styles.message, styles[type])}>
        <Icon name={icon} className={styles.icon} />
        <span>{message instanceof Error ? message.message : message}</span>
      </div>
    );
  }
}

Message.propTypes = {
  expire: PropTypes.func.isRequired,
  message: PropTypes.oneOfType([
    PropTypes.instanceOf(Error),
    PropTypes.string,
    PropTypes.element,
  ]).isRequired,
  type: PropTypes.oneOf(Object.keys(MESSAGES)),
};
